const bancos = {
  "001": "Banco do Brasil",
  "033": "Santander",
  "104": "Caixa Econômica Federal",
  "237": "Bradesco",
  "341": "Itaú",
  "748": "Sicredi",
  "756": "Sicoob",
  "422": "Safra",
  "077": "Inter",
  "260": "Nubank"
};

const segmentosArrecadacao = {
  "1": { nome: "Prefeituras", categoria: "impostos" },
  "2": { nome: "Saneamento", categoria: "agua" },
  "3": { nome: "Energia/Gás", categoria: "energia" },
  "4": { nome: "Telecomunicações", categoria: "outros" },
  "5": { nome: "Órgãos Governamentais", categoria: "impostos" },
  "6": { nome: "Carnes e Assemelhados", categoria: "outros" },
  "7": { nome: "Multas de Trânsito", categoria: "impostos" },
  "9": { nome: "Outros", categoria: "outros" }
};

const apenasDigitos = (valor) => String(valor || "").replace(/\D/g, "");

const modulo10 = (numero) => {
  let soma = 0;
  let peso = 2;
  const str = String(numero || "");
  for (let i = str.length - 1; i >= 0; i -= 1) {
    const n = parseInt(str.charAt(i), 10);
    const mult = n * peso;
    soma += Math.floor(mult / 10) + (mult % 10);
    peso = peso === 2 ? 1 : 2;
  }
  const resto = soma % 10;
  return resto === 0 ? 0 : 10 - resto;
};

const modulo11Boleto = (numero) => {
  let soma = 0;
  let peso = 2;
  const str = String(numero || "");
  for (let i = str.length - 1; i >= 0; i -= 1) {
    const n = parseInt(str.charAt(i), 10);
    soma += n * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  const dv = 11 - resto;
  return dv === 0 || dv === 10 || dv === 11 ? 1 : dv;
};

const modulo11Arrecadacao = (numero) => {
  let soma = 0;
  let peso = 2;
  const str = String(numero || "");
  for (let i = str.length - 1; i >= 0; i -= 1) {
    const n = parseInt(str.charAt(i), 10);
    soma += n * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  const dv = 11 - resto;
  return dv === 0 || dv === 1 || dv === 10 || dv === 11 ? 0 : dv;
};

const calcularDataVencimento = (fator) => {
  const numero = Number(fator);
  if (!Number.isFinite(numero) || numero <= 0) return null;
  const baseAntiga = new Date(1997, 9, 7);
  const dataAntiga = new Date(baseAntiga);
  dataAntiga.setDate(baseAntiga.getDate() + numero);
  if (numero < 1000) {
    return dataAntiga.toISOString().split("T")[0];
  }
  const baseNova = new Date(2025, 1, 22);
  const dataNova = new Date(baseNova);
  dataNova.setDate(baseNova.getDate() + (numero - 1000));
  const hoje = new Date();
  const diffAntiga = Math.abs(dataAntiga.getTime() - hoje.getTime());
  const diffNova = Math.abs(dataNova.getTime() - hoje.getTime());
  const escolhida = diffNova < diffAntiga ? dataNova : dataAntiga;
  return escolhida.toISOString().split("T")[0];
};

const gerarLinhaDigitavelBoleto = (codigoBarras) => {
  if (!codigoBarras || codigoBarras.length !== 44) return null;
  const bancoMoeda = codigoBarras.slice(0, 4);
  const dvGeral = codigoBarras.charAt(4);
  const fatorValor = codigoBarras.slice(5, 19);
  const campoLivre = codigoBarras.slice(19);
  const campo1 = bancoMoeda + campoLivre.slice(0, 5);
  const campo2 = campoLivre.slice(5, 15);
  const campo3 = campoLivre.slice(15, 25);
  const dv1 = modulo10(campo1);
  const dv2 = modulo10(campo2);
  const dv3 = modulo10(campo3);
  return `${campo1}${dv1}${campo2}${dv2}${campo3}${dv3}${dvGeral}${fatorValor}`;
};

const extrairBoletoCodigoBarras = (codigoBarras, inconsistencias, log) => {
  if (!codigoBarras || codigoBarras.length !== 44) {
    inconsistencias.push("Código de barras bancário inválido");
    return null;
  }
  const codigoBanco = codigoBarras.slice(0, 3);
  const moeda = codigoBarras.charAt(3);
  const dvGeral = codigoBarras.charAt(4);
  const fatorVencimento = codigoBarras.slice(5, 9);
  const valorStr = codigoBarras.slice(9, 19);
  const campoLivre = codigoBarras.slice(19);
  const dvCalculado = modulo11Boleto(codigoBarras.slice(0, 4) + codigoBarras.slice(5));
  if (String(dvCalculado) !== String(dvGeral)) {
    inconsistencias.push("Dígito verificador geral inválido");
  }
  const valorCentavos = parseInt(valorStr, 10);
  const valor = Number.isNaN(valorCentavos) ? null : valorCentavos / 100;
  const dataVencimento = calcularDataVencimento(fatorVencimento);
  const fornecedor = bancos[codigoBanco] || `Banco ${codigoBanco}`;
  log.push({ etapa: "boleto_bancario", detalhe: "Leitura do código de barras bancário" });
  return {
    tipo: "boleto_bancario",
    tipo_detalhado: "bancario",
    banco: { codigo: codigoBanco, nome: fornecedor },
    moeda,
    fator_vencimento: fatorVencimento,
    campo_livre: campoLivre,
    valor,
    valor_centavos: Number.isNaN(valorCentavos) ? null : valorCentavos,
    data_vencimento: dataVencimento,
    fornecedor
  };
};

const extrairBoletoLinhaDigitavel = (linha, inconsistencias, log) => {
  if (!linha || linha.length !== 47) {
    inconsistencias.push("Linha digitável bancária inválida");
    return null;
  }
  const campo1 = linha.slice(0, 9);
  const dv1 = linha.charAt(9);
  const campo2 = linha.slice(10, 20);
  const dv2 = linha.charAt(20);
  const campo3 = linha.slice(21, 31);
  const dv3 = linha.charAt(31);
  const dvGeral = linha.charAt(32);
  const fatorValor = linha.slice(33, 47);
  if (String(modulo10(campo1)) !== dv1) inconsistencias.push("Dígito verificador do campo 1 inválido");
  if (String(modulo10(campo2)) !== dv2) inconsistencias.push("Dígito verificador do campo 2 inválido");
  if (String(modulo10(campo3)) !== dv3) inconsistencias.push("Dígito verificador do campo 3 inválido");
  const codigoBarras = `${campo1.slice(0, 4)}${dvGeral}${fatorValor}${campo1.slice(4)}${campo2}${campo3}`;
  log.push({ etapa: "linha_digitavel", detalhe: "Linha digitável bancária convertida para código de barras" });
  return { codigoBarras, dv: { campo1: dv1, campo2: dv2, campo3: dv3, geral: dvGeral } };
};

const extrairArrecadacao = (codigo, inconsistencias, log) => {
  const referencia = codigo.charAt(2);
  const usaModulo10 = referencia === "6" || referencia === "7";
  const calculaDv = usaModulo10 ? modulo10 : modulo11Arrecadacao;
  let codigoBarras = codigo;
  let dv = {};
  if (codigo.length === 48) {
    const bloco1 = codigo.slice(0, 11);
    const dv1 = codigo.charAt(11);
    const bloco2 = codigo.slice(12, 23);
    const dv2 = codigo.charAt(23);
    const bloco3 = codigo.slice(24, 35);
    const dv3 = codigo.charAt(35);
    const bloco4 = codigo.slice(36, 47);
    const dv4 = codigo.charAt(47);
    if (String(calculaDv(bloco1)) !== dv1) inconsistencias.push("Dígito verificador do bloco 1 inválido");
    if (String(calculaDv(bloco2)) !== dv2) inconsistencias.push("Dígito verificador do bloco 2 inválido");
    if (String(calculaDv(bloco3)) !== dv3) inconsistencias.push("Dígito verificador do bloco 3 inválido");
    if (String(calculaDv(bloco4)) !== dv4) inconsistencias.push("Dígito verificador do bloco 4 inválido");
    codigoBarras = `${bloco1}${bloco2}${bloco3}${bloco4}`;
    dv = { bloco1: dv1, bloco2: dv2, bloco3: dv3, bloco4: dv4 };
    log.push({ etapa: "arrecadacao", detalhe: "Linha digitável de arrecadação convertida para código de barras" });
  }
  if (codigoBarras.length !== 44) {
    inconsistencias.push("Código de barras de arrecadação inválido");
    return null;
  }
  const dvGeral = codigoBarras.charAt(3);
  const dvCalculado = calculaDv(codigoBarras.slice(0, 3) + codigoBarras.slice(4));
  if (String(dvCalculado) !== dvGeral) inconsistencias.push("Dígito verificador geral inválido");
  const produto = codigoBarras.charAt(0);
  const segmento = codigoBarras.charAt(1);
  const valorDisponivel = referencia === "6" || referencia === "8";
  const valorStr = codigoBarras.slice(4, 15);
  const valorCentavos = valorDisponivel ? parseInt(valorStr, 10) : null;
  const valor = valorCentavos === null || Number.isNaN(valorCentavos) ? null : valorCentavos / 100;
  const segmentoInfo = segmentosArrecadacao[segmento] || { nome: "Arrecadação", categoria: "outros" };
  log.push({ etapa: "arrecadacao", detalhe: "Leitura do código de barras de arrecadação" });
  return {
    tipo: "arrecadacao",
    tipo_detalhado: segmentoInfo.nome,
    produto,
    segmento,
    referencia,
    valor,
    valor_centavos: valorCentavos,
    fornecedor: segmentoInfo.nome,
    categoria: segmentoInfo.categoria,
    dv: { geral: dvGeral, ...dv }
  };
};

const montarIntegracaoContabil = (dados) => ({
  origem: "contas_pagar",
  valor: dados.valor || null,
  data_vencimento: dados.data_vencimento || null,
  fornecedor: dados.fornecedor || null,
  categoria: dados.categoria || null,
  codigo_barras: dados.codigo_barras || null,
  linha_digitavel: dados.linha_digitavel || null
});

const extrairDadosCodigoBarras = (codigoBarras) => {
  const log = [];
  const inconsistencias = [];
  const codigoNormalizado = apenasDigitos(codigoBarras);
  if (!codigoNormalizado) {
    return {
      valido: false,
      codigo_input: codigoBarras || "",
      codigo_normalizado: "",
      inconsistencias: ["Código vazio"],
      log
    };
  }
  let resultado = null;
  let linhaDigitavel = null;
  let codigoBarrasFinal = null;
  if (codigoNormalizado.length === 47) {
    const dadosLinha = extrairBoletoLinhaDigitavel(codigoNormalizado, inconsistencias, log);
    if (dadosLinha?.codigoBarras) {
      codigoBarrasFinal = dadosLinha.codigoBarras;
      linhaDigitavel = codigoNormalizado;
      const dadosBarras = extrairBoletoCodigoBarras(codigoBarrasFinal, inconsistencias, log);
      resultado = { ...dadosBarras, dv: { ...(dadosLinha.dv || {}), geral: dadosLinha.dv?.geral } };
    }
  } else if (codigoNormalizado.length === 44 && codigoNormalizado.startsWith("8")) {
    codigoBarrasFinal = codigoNormalizado;
    resultado = extrairArrecadacao(codigoNormalizado, inconsistencias, log);
  } else if (codigoNormalizado.length === 44) {
    codigoBarrasFinal = codigoNormalizado;
    resultado = extrairBoletoCodigoBarras(codigoNormalizado, inconsistencias, log);
  } else if (codigoNormalizado.length === 48 && codigoNormalizado.startsWith("8")) {
    linhaDigitavel = codigoNormalizado;
    resultado = extrairArrecadacao(codigoNormalizado, inconsistencias, log);
    if (resultado) {
      codigoBarrasFinal = codigoNormalizado.slice(0, 11) + codigoNormalizado.slice(12, 23) + codigoNormalizado.slice(24, 35) + codigoNormalizado.slice(36, 47);
    }
  } else {
    inconsistencias.push("Tamanho de código inválido");
  }
  const valido = inconsistencias.length === 0;
  const dados = resultado || {};
  const linhaGerada = linhaDigitavel || (codigoBarrasFinal && dados.tipo === "boleto_bancario" ? gerarLinhaDigitavelBoleto(codigoBarrasFinal) : null);
  const payload = {
    valido,
    codigo_input: codigoBarras || "",
    codigo_normalizado: codigoNormalizado,
    linha_digitavel: linhaDigitavel || linhaGerada,
    codigo_barras: codigoBarrasFinal,
    tipo: dados.tipo || null,
    tipo_detalhado: dados.tipo_detalhado || null,
    valor: dados.valor ?? null,
    valor_centavos: dados.valor_centavos ?? null,
    data_vencimento: dados.data_vencimento || null,
    fornecedor: dados.fornecedor || null,
    categoria: dados.categoria || null,
    beneficiario: null,
    banco: dados.banco || null,
    campos: {
      moeda: dados.moeda || null,
      fator_vencimento: dados.fator_vencimento || null,
      campo_livre: dados.campo_livre || null,
      segmento: dados.segmento || null,
      referencia: dados.referencia || null
    },
    dv: dados.dv || null,
    inconsistencias,
    log
  };
  return { ...payload, integracao_contabil: montarIntegracaoContabil(payload) };
};

export {
  extrairDadosCodigoBarras,
  modulo10,
  modulo11Boleto,
  modulo11Arrecadacao,
  gerarLinhaDigitavelBoleto
};
